import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'AppReducer'
import { getUserByPerson } from '../redux/actions'

import UserCard from '../manager/components/UserCard'
import UserList from '../manager/components/UserList'
import UserExtraMenu from '../manager/components/UserExtraMenu'

import ContactForm from './ContactForm'
import ContactList from './ContactList'

const ContactManager: React.FC = () => {
  const { personId } = useParams<{ personId: string }>()

  const dispatch = useDispatch()
  const { user } = useSelector((state: ApplicationState) => state.userReducer)

  useEffect(() => {
    if (personId && !user) {
      getUserByPerson(personId)(dispatch)
    }
  }, [personId, user, dispatch])

  return (
    <div className="row">
      <div className="row padding-left-8 margin-bottom-16">
        <div className="row" style={{ width: 400 }}>
          <h1 className="col-12 bold-center">Gestão de Contatos</h1>
          <p className="col-12 no-margin">Crie, edite, busque e remova contatos</p>
        </div>
        <div className="row grow padding-left-16">
          <UserExtraMenu />
        </div>
      </div>

      <UserCard />

      <div className="row panel margin-top-16">
        <ContactForm />
        <ContactList />
      </div>

      <UserList />
    </div>
  )
}

export default ContactManager
